<template>
    <div class="main-wrapper">
        <div class="row-main">
            <div class="titleMain">
                <div class="blueBorder"></div>
                <div style="float:left;">政策法规</div>
                <div class="titleTag">/NEWS</div>
                <div class="more" @click="handleDeal('policiesAndRegulations','政策法规')">MORE</div>
            </div>
            <div class="boderLine"></div>
            <Row :gutter="30" style="height:290px;overflow:hidden;">
                <Col span="10">
                    <img class="noticeImg" :src="zcfgSrc" alt="">
                    <div class="noticeTitle">{{zcfgItem.title}}</div>
                    <div class="noticeText" v-html='zcfgItem.content'></div>
                </Col>
                <Col span="14" style="padding: 20px">
                    <div class="noticeMain" @click="noticeDeal(item)" v-for="item in zcfg" :key="item.uuid">
                        <div class="noticeInfo">{{item.title}}</div>
                        <div class="noticeDate">{{item.pubTime}}</div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="row-main">
            <div class="titleMain">
                <div class="blueBorder"></div>
                <div style="float:left;">通知公告</div>
                <div class="titleTag">/NOTICE ANNOUNCEMENT</div>
                <div class="more"  @click="handleDeal('policiesAndRegulations','通知公告')">MORE</div>
            </div>
            <div class="boderLine"></div>
            <Row :gutter="30" style="height:290px;overflow:hidden;">
                <Col span="10">
                    <img class="noticeImg" :src="tzggSrc" alt="">
                    <div class="noticeTitle">{{tzggItem.title}}</div>
                    <div class="noticeText" v-html='tzggItem.content'></div>
                </Col>
                <Col span="14" style="padding: 20px">
                    <div class="noticeMain" @click="noticeDeal(item)" v-for="item in tzgg" :key="item.uuid">
                        <div class="noticeInfo">{{item.title}}</div>
                        <div class="noticeDate">{{item.pubTime}}</div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="row-main">
            <div class="titleMain">
                <div class="blueBorder"></div>
                <div style="float:left;">诚信信息</div>
                <div class="titleTag">/INTEGRITY INFORMATION</div>
                <div class="more" @click="goMain('creditInfop')">MORE</div>
                <div class="tabs">
                    <div @click="tabClick(1)" :class="tabShow == 1?'tab-active':'tab-tag'">企业诚信</div>
                    <div @click="tabClick(2)" :class="tabShow == 2?'tab-active':'tab-tag'">个人诚信</div>
                </div>
            </div>
            <div class="boderLine"></div>
            <Row style="margin-top:10px;margin-bottom:10px;" v-if="tabShow == 1">
                <Col span="3">信用性质</Col>
                <Col span="4">单位名称</Col>
                <Col span="2">法人</Col>
                <Col span="7">认定内容</Col>
                <Col span="4">认定部门</Col>
                <Col span="3">公开时间</Col>
            </Row>
            <Row v-for="item,index in cxxx" :key='index' style="padding:10px 0;border-bottom:0.5px solid #EAEAEA;height:62px;line-height:42px;overflow:hidden;" v-if="tabShow == 1">
                <!-- <Col span="3" v-if="item.creditStatus != '良好信用'"><span class="redTag">{{item.creditStatus}}</span></Col>
                <Col span="3" v-else ><span class="blueTag">{{item.creditStatus}}</span></Col> -->
                <Col span="3" v-if="item.creditStatus == '良好信用'"><span class="blueTag ft-smaller">{{item.creditStatus}}</span></Col>
                <Col span="3" v-if="item.creditStatus == '轻微不良信用'"><span class="yellowTag ft-smaller">{{item.creditStatus}}</span></Col>
                <Col span="3" v-if="item.creditStatus == '一般不良信用'"><span class="orangeTag ft-smaller">{{item.creditStatus}}</span></Col>
                <Col span="3" v-if="item.creditStatus == '严重不良信用'"><span class="redTag ft-smaller">{{item.creditStatus}}</span></Col>
                <Col span="3" v-if="item.creditStatus == null"><span>-</span></Col>
                <Col span="4" ><p style="font-weight:700;line-height:21px;cursor: pointer" @click="handleDealCXXX('creditInfoDetail',item.uuid, true)">{{item.corpName?item.corpName:'-'}}</p><p style="line-height:21px;">{{item.corpCode?item.corpCode:'-'}}</p></Col>
                <Col span="2">{{item.legalMan?item.legalMan:'-'}}</Col>
                <Col span="7" class="rowBox"><span :title="item.mark" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: block;width: 100%">{{item.mark}}</span></Col>
                <Col span="4" class="">{{item.affirmDepartment}}</Col>
                <Col span="3">{{item.publicDate}}</Col>
            </Row>
            <Row style="margin-top:10px;margin-bottom:10px;" v-if="tabShow == 2">
                <Col span="3">信用性质</Col>
                <Col span="2">姓名</Col>
                <Col span="4">身份证号码</Col>
                <Col span="7">认定内容</Col>
                <Col span="4">认定部门</Col>
                <Col span="3">公开时间</Col>
            </Row>
            <Row v-for="item,index in grcxxx" :key='index' style="padding:10px 0;border-bottom:0.5px solid #EAEAEA" v-if="tabShow == 2">
                <Col span="3" v-if="item.creditNature == '良好信用'"><span class="blueTag">{{item.creditNature}}</span></Col>
                <Col span="3" v-if="item.creditNature == '轻微不良信用'"><span class="yellowTag">{{item.creditNature}}</span></Col>
                <Col span="3" v-if="item.creditNature == '一般不良信用'"><span class="orangeTag">{{item.creditNature}}</span></Col>
                <Col span="3" v-if="item.creditNature == '严重不良信用'"><span class="redTag">{{item.creditNature}}</span></Col>
                <Col span="2" class="rowBox"><span style="cursor: pointer" @click="handleDealCXXX('creditInfoDetail',item.uuid, true)">{{item.personName}}</span></Col>
                <Col span="4" class="rowBox">{{item.idCard}}</Col>
                <Col span="7" class="rowBox">{{item.fContent?item.fContent:'-'}}</Col>
                <Col span="4" class="rowBox">{{item.departName?item.departName:'-'}}</Col>
                <Col span="3" class="rowBox">{{item.openDate?item.openDate:'-'}}</Col>
            </Row>
        </div>
        <Row :gutter="25">
            <Col span="12">
                <div class="row-main">
                    <div class="titleMain">
                        <div class="blueBorder"></div>
                        <div style="float:left;">企业黑名单</div>
                        <div class="more" @click="goMain('blackListp')">MORE</div>
                    </div>
                    <img class="blackImg" src="../../../assets/blackList.jpg" alt="">
                    <div style="height: 160px">
                        <Row v-for="item,index in qyBlack" :key='index' style="height:40px;line-height:40px;overflow:hidden; border-bottom: 0.5px solid #EAEAEA" >
                            <div @click="goBlack(item,1)" style="cursor: pointer; text-align: left">
                                <Col span="8" style="font-weight:700;"><span class='li-title'>{{item.name}}</span></Col>
                                <Col offset='1' style="text-align:center;" span="10">{{item.cognizanceBasis}}</Col>
                                <Col span="5" style="text-align:right;">{{item.blacklistStartDate}}</Col>
                            </div>
                        </Row>
                    </div>
                </div>
            </Col>
            <Col span="12" style="background: #fff;">
                <div class="row-main">
                    <div class="titleMain">
                        <div class="blueBorder"></div>
                        <div style="float:left;">个人黑名单</div>
                        <div class="more" @click="goMain('blackListp')">MORE</div>
                    </div>
                    <img class="blackImg" src="../../../assets/blackList.jpg" alt="">
                    <div style="height: 140px">
                        <Row v-for="item,index in grBlack" :key='index' style="height:40px;line-height:40px;border-bottom: 0.5px solid #EAEAEA" >
                            <div @click="goBlack(item,2)" style="cursor: pointer; text-align: left">
                                <Col span="8" style="font-weight:700;"><span class='li-title'>{{item.name}}</span></Col>
                                <Col offset='1' style="text-align:center;" span="10">{{item.cognizanceBasis}}</Col>
                                <Col span="5" style="text-align:right;">{{item.blacklistStartDate}}</Col>
                            </div>
                        </Row>
                    </div>
                </div>
            </Col>
        </Row>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPolicesAndRegulationList,getWebPortalCreditInfo, getCreditInfoList, getBlackListList,personalIntegritys } from '@/api/homePage.js';
import zcfgImg from '@/assets/zcfg.jpg'
import tzggImg from '@/assets/tzgg.png'

    export default {
        data(){
            return {
                zcfgImg,
                tzggImg,
                tabShow:1,
                zcfg:[],
                zcfgItem: {},
                tzgg:[],
                 tzggItem: {},
                cxxx:[],
                qyBlack:[],
                grBlack:[],
                grcxxx:[],
                zcfgSrc: '',
                tzggSrc: ''
            };
        },
        computed: {
            ...mapGetters(['_dict', 'slideshowIp'])
        },
        created(){
            this.initData()
        },
        mounted(){
            this.zcfgSrc = this.zcfgImg
            this.tzggSrc = this.tzggImg
        },
        watch: {

        },
        methods: {
            tabClick(value) {
                this.tabShow = value
            },
            repalceHtml(str) {
                str = str.replace(/<[^>]+>|&[^>]+;/g,"").replace(/\s+/g, '').trim();//去掉所有的html标签和&nbsp;之类的特殊符合
                return str;
            },
            initData() {
                let zcfg = {num: 1, size: 5, typeCode: '01', pubStateCode: '02'}
                getPolicesAndRegulationList(zcfg).then((res) => {
                    if (res.status === 200) {
                        const { total } = res.data.data
                        let list = res.data.data.list
                        if (Array.isArray(list) && list.length > 0) {
                            list = list.filter((it) => it.pubStateCode != '03')
                            this.zcfg = list
                            const item = list.find((it) => it.remarks && it.remarks.length > 0 && it.remarks.some((item) => item.contentType == '01'))
                            let imgObj = {}
                            let src = this.zcfgImg
                            if (item) {
                                item.content = this.repalceHtml(item.content)
                                this.zcfgItem = item
                                const { remarks } = item
                                imgObj = remarks.find((it) => it.contentType == '01')
                                if (imgObj) {
                                    src = this.slideshowIp + 'static/file/' + imgObj.diskFileName
                                }
                            } else {
                                list[0].content = this.repalceHtml(list[0].content)
                                this.zcfgItem = list[0] || {}
                            }
                            this.zcfgSrc = src
                        }
                    }
                })
                let tzgg = {num: 1, size: 5, typeCode: '02', pubStateCode: '02'}
                getPolicesAndRegulationList(tzgg).then((res) => {
                    if (res.status === 200) {
                        const { total } = res.data.data
                        let list = res.data.data.list
                        if (Array.isArray(list) && list.length > 0) {
                            list = list.filter((it) => it.pubStateCode != '03')
                            this.tzgg = list
                            const item = list.find((it) => it.remarks && it.remarks.length > 0 && it.remarks.some((item) => item.contentType == '01'))
                            let imgObj = {}
                            let src = this.tzggImg
                            if (item) {
                                item.content = this.repalceHtml(item.content)
                                this.tzggItem = item
                                const { remarks } = item
                                imgObj = remarks.find((it) => it.contentType == '01')
                                if (imgObj) {
                                    src = this.slideshowIp + 'static/file/' + imgObj.diskFileName
                                }
                            } else {
                                list[0].content = this.repalceHtml(list[0].content)
                                this.tzggItem = list[0] || {}
                            }
                            this.tzggSrc = src
                        }
                    }
                })
                let grcxxx = {
                    num:1,
                    size:8,
                }
                personalIntegritys(grcxxx).then((res) => {
                    console.log(res)
                    this.grcxxx = res.data.data.list
                }).catch(() => {
                    this.$Message.error('获取列表信息失败')
                })
                let cxxx ={
                    creditStatus:2,
                    corpName:'',
                    affirmDepartment:'',
                    page:1,
                    pageSize:10
                }
                getWebPortalCreditInfo().then((res) => {
                    // console.log(res)
                    this.cxxx = res.data
                }).catch(() => {
                    this.$Message.error('获取列表信息失败')
                })
                let qyBlack = {
                    blackCategory:1,
                    currentPage: 1,
                    pageSize: 4
                }
                getBlackListList(qyBlack).then((res) => {
            //         console.log(res)
                    if (res.status === 200) {
                      const { list, total } = res.data
                      this.qyBlack = list
                    }
                  }).catch(() => {
                    this.$Message.error('获取列表信息失败')
                  })
                let grBlack = {
                    blackCategory:2,
                    currentPage: 1,
                    pageSize: 4
                }
                getBlackListList(grBlack).then((res) => {
            //         console.log(res)
                    if (res.status === 200) {
                      const { list, total } = res.data
                      this.grBlack = list
                    }
                  }).catch(() => {
                    this.$Message.error('获取列表信息失败')
                  })

            },
            handleDealCXXX(name, uuid){
                this.$router.push({
                    name: name,
                    query: {
                        uuid
                    }
                });
            },
            //政策法规、通知公告详情跳转
            noticeDeal(row) {
                this.$router.push({
                    name: 'policiesAndRegulationsDetail',
                    query: {
                        id: row.id, type: this.$route.query.type == '政策法规' ? '01' : '02'
                    }
                });
            },
            goMain(name) {
                this.$router.push({
                    name: name,
                });
            },
            goBlack(item,value){
                if(value == 1){
                    this.$router.push({
                        name: value == 1 ? 'blackListCorpDetail' : 'blackListPersonDetail',
                        query:{corpCode: item.code}
                    });
                }else {
                    this.$router.push({
                        name: value == 1 ? 'blackListCorpDetail' : 'blackListPersonDetail',
                        query:{idCard18: item.code}
                    });
                }

            },
            handleDeal(name, type){
                this.$router.push({
                    name: name,
                    query: {
                        type
                    }
                });
            }
    },
}
</script>
<style lang="less" scoped>
    .ft-smaller {
        font-size: smaller;
    }
   .main-wrapper {
       width: 100%;
        .row-main {
            width: 100%;
            background: white;
            padding: 15px;
            margin-bottom: 20px;
            text-align: center;
           .rowBox {
                line-height:21px;
                overflow:hidden;
                height:42px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
                -webkit-box-pack: center;
                -webkit-box-align: center;

                display: -moz-box;
                -moz-box-orient: horizontal;
                -moz-box-pack: center;
                -moz-box-align: center;

                display: -o-box;
                -o-box-orient: horizontal;
                -o-box-pack: center;
                -o-box-align: center;

                display: -ms-box;
                -ms-box-orient: horizontal;
                -ms-box-pack: center;
                -ms-box-align: center;

                display: box;
                box-orient: horizontal;
                box-pack: center;
                box-align: center;
           }
           .redTag {
               padding: 3px 5px;
               background: #FF0000;
               color: white;
               width: 100px;
               display: block;
               margin: 7px auto;
               line-height: 21px;
           }
           .yellowTag {
               padding: 3px 5px;
               background: #FF7700;
               color: white;
               width: 100px;
               display: block;
               margin: 7px auto;
               line-height: 21px;
           }
           .orangeTag {
               padding: 3px 5px;
               background: #FF4400;
               color: white;
               width: 100px;
               display: block;
               margin: 7px auto;
               line-height: 21px;
           }
           .blueTag {
               padding: 3px 5px;
               background: #33CC00;
               color: white;
               width: 100px;
               display: block;
               margin: 7px auto;
               line-height: 21px;
           }
           .boderLine {
                height: 1px;
                width: 100%;
                background: #cccccc;
                margin-top: 20px;
            }
           .titleMain {
               height: 30px;
               line-height: 30px;
               font-size: 18px;
               font-weight: 700;
               .tabs {
                   height: 30px;
                   line-height: 30px;
                   width: 200px;
                   float: right;
                   font-size: 14px;
                   .tab-tag {
                       width: 100px;
                       float: left;
                       cursor: pointer;
                   }
                   .tab-active {
                       width: 100px;
                       float: left;
                       color: #2d8cf0;
                       cursor: pointer;
                   }
               }
               .blueBorder {
                   height: 30px;
                   width: 3px;
                   background: #2d8cf0;
                   float: left;
                   margin-right: 10px;
               }
               .titleTag {
                   font-size: 12px;
                   color: gray;
                   margin-left: 10px;
                   margin-top:4px;
                   float: left;
               }
               .more {
                   height: 30px;
                   color: #2d8cf0;
                   border: 1px solid #2d8cf0;
                   border-radius: 30px;
                   float: right;
                   font-size: 14px;
                   font-weight: 500;
                   width: 60px;
                   line-height: 30px;
                   text-align: center;
                   cursor: pointer;
               }

            }
            .blackImg {
                width: 100%;
                height: 150px;
                margin-top: 10px;
            }
            .noticeImg {
                width: 100%;
                height: 150px;
                margin-top: 10px;
            }
            .noticeTitle {
                width: 100%;
                letter-spacing: 1px;
                font-size: 15px;
                height: 40px;
                line-height: 36px;
                color: #909090;
                font-weight: 700;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .noticeText {
                text-align: left;
                color: #808080;
                overflow : hidden;
                line-height: 25px;
                letter-spacing: 1px;
                padding: 0 15px;
                height: 70px;
                text-indent: 25px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            .noticeMain {
                height: 50px;
                line-height: 50px;
                font-size: 14px;
                float: left;
                width: 100%;
                border-bottom: 0.5px solid #EAEAEA;
            }
            .noticeInfo {
                height: 50px;
                width: 80%;
                float: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 15px;
                color: #808080;
                padding-left: 16px;
                text-align: left;
                position: relative;
                cursor: pointer;
                &::before {
                    content: '';
                    position: absolute;
                    left: 0px;
                    top: -3px;
                    height: 10px;
                    width: 10px;
                    border: 1px solid #D0D0D0;
                    border-radius: 5px;
                    top: 50%;
                    transform: translate(0, -50%);
                }
            }
            .noticeDate {
                height: 50px;
                line-height: 50px;
                float: right;
                width: 20%;
                color: #cccccc;
                text-align: right;
            }
       }
    }
    .li-title {
        padding-left: 16px;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            left: 0px;
            top: -3px;
            height: 10px;
            width: 10px;
            background: #D6D6D6;
            border-radius: 5px;
            top: 50%;
            transform: translate(0, -50%);
       }
   }
</style>
<style>

</style>
